import Joi from '@hapi/joi';
import { getMetadataValue } from '../../components/Surveys/Common/getMetadataValue';

export const metaDataSchema = Joi.object().keys({
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Faaloorzaak: Joi.string().allow(null, ''),
    'Gevolg van falen': Joi.string().allow(null, ''),
    'Bron van falen': Joi.string().allow(null, ''),
    'Faaloorzaak anders': Joi.string().when('Faaloorzaak', { is: '4', then: Joi.required(), otherwise: Joi.allow(null, '') }),
    'Bron van falen anders': Joi.string().when('Bron van falen', { is: '7', then: Joi.required(), otherwise: Joi.allow(null, '') }),
});

export const metaDataDefinition = [
    {
        name: 'Faaloorzaak',
        control: 'dropdown',
        options: [
            { value: '1', text: 'Externe invloed' },
            { value: '2', text: 'Overbelasting' },
            { value: '3', text: 'Te geringe belastbaarheid' },
            // { value: '4', text: 'Lekkage' },
            // { value: '5', text: 'Niet (juist) aangebracht' },
            // { value: '6', text: 'Niet (juist) uitgevoerd' },
            // { value: '7', text: 'Slijtage / Veroudering' },
            // { value: '8', text: 'Uitspoeling' },
            // { value: '9', text: 'Verandering normen' },
            // { value: '10', text: 'Verontreiniging' },
            // { value: '11', text: 'Vervorming' },
            // { value: '12', text: 'Verstopping' },
            // { value: '13', text: 'Zettingen' },
            { value: '4', text: 'Anders' },
        ],
    },
    {
        name: 'Faaloorzaak anders',
        control: 'inputtext',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        showWhen: (metadata: { Faaloorzaak: string }) => metadata && metadata.Faaloorzaak === '4',
    },
    {
        name: 'Bron van falen',
        control: 'dropdown',
        options: [
            { value: '1', text: 'Bediening' },
            { value: '2', text: 'Einde levensduur' },
            { value: '3', text: 'Onderhoud' },
            { value: '4', text: 'Ontwerp' },
            { value: '5', text: 'Realisatie' },
            { value: '6', text: 'Wet & regelgeving' },
            { value: '7', text: 'Anders' },
        ],
    },
    {
        name: 'Bron van falen anders',
        control: 'inputtext',
        showWhen: (metadata: { 'Bron van falen': string }) => metadata && metadata['Bron van falen'] === '7',
    },
    {
        name: 'Gevolg van falen',
        control: 'inputtext',
    },
    // {
    //     name: 'Gevolg van falen',
    //     control: 'dropdown',
    //     options: [
    //         { value: '1', text: 'Grootschalige schade' },
    //         { value: '2', text: 'Niet beschikbaar' },
    //         { value: '3', text: 'Niet betrouwbaar' },
    //         { value: '4', text: 'Niet onderhoudbaar' },
    //         { value: '5', text: 'Niet veilig' },
    //         { value: '6', text: 'Niet voldoen aan (constructieve) eisen' },
    //         { value: '7', text: 'Niet Voldoen aan regelgeving' },
    //         { value: '8', text: 'Anders' },
    //     ]
    // }, {
    //     name: 'Gevolg van falen anders',
    //     control: 'inputtext',
    //     showWhen: (metadata: { 'Gevolg van falen': string }) => metadata && metadata['Gevolg van falen'] === '8'
    // }
];

export function getFailureCause(metaData: any) {
    if (metaData.Faaloorzaak === '4') {
        return metaData['Faaloorzaak anders'];
    }
    return getMetadataValue({ metaDataItem: metaDataDefinition.find((i) => i.name === 'Faaloorzaak'), itemValue: metaData.Faaloorzaak || '' });
}

export function getFailureOrigin(metaData: any) {
    if (metaData['Bron van falen'] === '7') {
        return metaData['Bron van falen anders'];
    }
    return getMetadataValue({
        metaDataItem: metaDataDefinition.find((i) => i.name === 'Bron van falen'),
        itemValue: metaData['Bron van falen'] || '',
    });
}

export function getFailureModeDisplayName(failureModeToDisplay: {
    customName?: undefined | string | null;
    metaData?: undefined | string | null;
    defaultFailureMode: { name?: undefined | string | null };
}) {
    return `${
        failureModeToDisplay.defaultFailureMode && failureModeToDisplay.defaultFailureMode.name
            ? failureModeToDisplay.defaultFailureMode.name
            : failureModeToDisplay.customName
              ? failureModeToDisplay.customName
              : ''
    } | ${getFailureCause(failureModeToDisplay.metaData)} | ${getFailureOrigin(failureModeToDisplay.metaData)}`;
}
